import './App.css';
import { useUser } from './context/UserContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import './components/styles/global.css';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BrowserRouter as Router, Route, Routes, useNavigate, useLocation, Navigate } from 'react-router-dom';
import Navbar from  './components/public/Navbar'
import Navbar2 from  './components/admin/Navbar2'
import HSNavbar2 from './components/admin/HSNavbar2';
import StudentNavbar from  './components/student/Navbar'
import AdminStudentNavbar from './components/admin/AdminStudentNavbar';
import BaselinePlanNavbar from './components/admin/BaselinePlanNavbar';
import HomePage from './components/public/HomePage'; 
import SignUp from './components/public/SignUp';
import LogIn from './components/public/Login2';
import StudentOnboarding from './components/student/StudentOnboarding';
import AdminOnboarding from './components/admin/AdminOnboarding';
import CoursePage from './components/admin/CoursePage2';
import StudentCoursePage from './components/student/CoursePage2';
import Profile from './components/admin/Profile';
import BlogPost from './components/public/BlogPost';
import PathwaysTab from './components/admin/PathwaysTab';
import StudentPathwaysTab from './components/student/PathwaysTab';
import CoursesTab from './components/admin/CoursesTab';
import PartnerCoursesTab from './components/admin/PartnerCoursesTab';
import StudentCoursesTab from './components/student/CoursesTab';
import PathwayPage from './components/admin/PathwayPage';
import StudentPathwayPage from './components/student/PathwayPage';
import FourYearPlan from './components/student/FourYearPlan';
import StudentsList from './components/admin/StudentsList';
import Test from './components/Test'
import ForgotPassword from './components/public/ForgotPassword';
import ResetPassword from './components/public/ResetPassword';
import ParentStudentsList from './components/parent/ParentStudentsList';
import ParentStudentNavbar from './components/parent/ParentStudentNavbar';
import ParentNavbar from './components/parent/ParentNavbar';
import OnboardingQuestions from './components/student/OnboardingQuestions';
import PrivacyPolicy from './components/public/PrivacyPolicy';
import BaselinePlans from './components/admin/BaselinePlans';
import BaselinePlanSelection from './components/student/BaselinePlanSelection';
import StudentInfo from './components/student/StudentInfo';
import StudentDemographics from './components/student/StudentDemographics';
import CCCApplyConfirmation from './components/student/CCCApplyConfirmation';
import CCCApplySuccess from './components/student/CCCApplySuccess';
import CCCApplyConsent from './components/student/CCCApplyConsent';
import CCCApplyApplication from './components/student/CCCApplyApplication';
import ParentForm from './components/student/ParentForm';
import SignParentConsentForm from './components/parent/ParentSignForm';
import ParentFormViewer from './components/admin/ParentFormViewer';
import ParentFormSuccess from './components/student/ParentFormSuccess';
import TermsOfUse from './components/public/TermsOfUse';
import ServiceAgreement from './components/public/ServiceAgreement';
import AcceptableUsePolicy from './components/public/AcceptableUsePolicy';
import ParentApplicationPage from './components/parent/ParentApplicationPage';
import ParentApplicationNavbar from './components/parent/ParentApplicationNavbar';
import ParentDualSchoolLogin from './components/public/ParentDualSchoolLogin';
import ParentApplicationsSection from './components/parent/ParentApplicationsSection';
import ParentPayments from './components/parent/ParentPayments';
import ParentApplicationSummary from './components/parent/ParentApplicationSummary';
import EnrollmentContract from './components/parent/EnrollmentContract';
import DirectoryOptOutForm from './components/parent/DirectoryOptOutForm';
import EnrollmentSuccess from './components/parent/EnrollmentSuccess';

function AppRoutes({ isAuthenticated, userType, schoolType, isAdminViewingAsStudent, isParentViewingAsStudent, applicationStep, setApplicationStep }) {
  const navigate = useNavigate();
  const location = useLocation();

  const cachedUser = JSON.parse(localStorage.getItem('cachedUser'));
  const appStatus = cachedUser && cachedUser.application_status;
  const dualSchoolEnabled = cachedUser && cachedUser.school && cachedUser.school.dual_school_enabled;

  // Debugging output
  console.log('AppRoutes restriction check:', {
    isAuthenticated,
    userType,
    schoolType,
    isAdminViewingAsStudent,
    isParentViewingAsStudent,
    dualSchoolEnabled,
    appStatus,
    path: location.pathname
  });

  // Restrict all routes except /application for dual school parents with incomplete application
  if (
    isAuthenticated &&
    userType === 3 &&
    !isParentViewingAsStudent &&
    schoolType === 'HS' &&
    dualSchoolEnabled &&
    (appStatus === 'not_started' || appStatus === 'in_progress')
  ) {
    if (location.pathname !== '/application') {
      return <Navigate to="/application" replace />;
    }
    // Only render the application page route
    return (
      <Routes>
        <Route path="/application" element={<ParentApplicationPage step={applicationStep} setStep={setApplicationStep} />} />
      </Routes>
    );
  }

  const renderRootRoute = () => {
    if (!isAuthenticated) {
      return <HomePage />;
    } else if (userType === 2 && !isAdminViewingAsStudent) {
      return <CoursesTab />;
    } else if (userType === 3 && !isParentViewingAsStudent) {
      return <ParentStudentsList />; // Student view for parents
    } else if (isParentViewingAsStudent) {
      return <FourYearPlan />; // Student view for parents
    } else {
      return <FourYearPlan />; // Default student view
    }
  };

  return (
    <Routes>
      <Route path="/" element={renderRootRoute()} />
      <Route path="/sign-up" element={<SignUp />} />
      <Route path="/log-in" element={<LogIn />} />
      <Route path="/dual-parent-login" element={<ParentDualSchoolLogin />} />
      <Route path="/student-onboarding" element={<StudentOnboarding />} />
      <Route path="/admin-onboarding" element={<AdminOnboarding />} />
      <Route path="/course-page/:id" element={userType === 2 ? <CoursePage /> : <StudentCoursePage />} />
      <Route path="/blog-page/:id" element={<BlogPost />} />
      <Route path="/pathways/:id" element={userType === 2 ? <PathwayPage /> : <StudentPathwayPage />} />
      <Route path="/pathways" element={userType === 2 ? <PathwaysTab /> : <StudentPathwaysTab />} />
      <Route path="/courses" element={userType === 2 ? <CoursesTab /> : <StudentCoursesTab />} />
      <Route path="/partner-courses" element={<PartnerCoursesTab />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/plan" element={<FourYearPlan />} />
      <Route path="/students-list" element={<StudentsList />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password/:uidb64/:token" element={<ResetPassword />} />
      <Route path="/parent-home" element={<ParentStudentsList />} />
      <Route path="/parent-applications" element={<ParentApplicationsSection />} />
      <Route path="/onboarding-questions" element={<OnboardingQuestions />} />
      <Route path="/baseline-plans" element={<BaselinePlanSelection />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/auto-gen-plans" element={<BaselinePlans />} />
      <Route path="/student-info" element={<StudentInfo />} />
      <Route path="/student-demographics" element={<StudentDemographics />} />
      <Route path="/cccapply/consent" element={<CCCApplyConsent />} />
      <Route path="/cccapply/confirmation" element={<CCCApplyConfirmation />} />
      <Route path="/cccapply/application" element={<CCCApplyApplication />} />
      <Route path="/cccapply/success" element={<CCCApplySuccess />} />
      <Route path="/parent-form" element={<ParentForm />} />
      <Route path="/parent-sign/:code" element={<SignParentConsentForm />} />
      <Route path="/parent-form-viewer/:code" element={<ParentFormViewer />} />
      <Route path="/parent-form-success" element={<ParentFormSuccess />} />
      <Route path="/test" element={<Test />} />
      <Route path="/terms-of-use" element={<TermsOfUse />} />
      <Route path="/service-agreement" element={<ServiceAgreement />} />
      <Route path="/acceptable-use-policy" element={<AcceptableUsePolicy />} />
      <Route path="/application" element={<ParentApplicationPage step={applicationStep} setStep={setApplicationStep} />} />
      <Route path="/application-summary" element={<ParentApplicationSummary />} />
      <Route path="/parent-payments" element={<ParentPayments />} />
      <Route path="/enrollment-contract" element={<EnrollmentContract />} />
      <Route path="/directory-opt-out-form" element={<DirectoryOptOutForm />} />
      <Route path="/enrollment-success" element={<EnrollmentSuccess />} />
    </Routes>
  );
}

function App() {
  // const { user, isAuthenticated, isLoading } = useUser();

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userType, setUserType] = useState(null);
  const [schoolType, setSchoolType] = useState(null);
  const [isAdminViewingAsStudent, setIsAdminViewingAsStudent] = useState(localStorage.getItem('isAdminViewingAsStudent') === 'true'); // New state
  const [isParentViewingAsStudent, setIsParentViewingAsStudent] = useState(localStorage.getItem('isParentViewingAsStudent') === 'true');
  const [applicationStep, setApplicationStep] = useState(parseInt(localStorage.getItem('applicationStep') || '0'));

  useEffect(() => {
    const handleStorage = () => {
      setApplicationStep(parseInt(localStorage.getItem('applicationStep') || '0'));
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
  const token = localStorage.getItem('token');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    
    
    const fetchCurrentUser = async () => {
      try {
        const headers = {};
        if (token) {
          headers['Authorization'] = `Token ${token}`;
        }
        const cachedUser = localStorage.getItem('cachedUser');        
          const response = await axios.get(`${API_ENDPOINT}/api/current-user/`, { headers });
          localStorage.setItem('cachedUser', JSON.stringify(response.data));
          console.log('Fetched current user:', response.data);
          setIsAuthenticated(true);
          setUserType(response.data.user_type);
          setSchoolType(response.data.school.school_type);
          setIsLoading(false);
      } catch (error) {
        console.error("Error fetching current user:", error);
        setIsLoading(false);
      }
    };

    if (token) {
      fetchCurrentUser();
    } else {
      setIsLoading(false);
    }
  }, [API_ENDPOINT, token]);



  if (isLoading) {
    return null;
  }

  // Check if this is a dual school parent with incomplete application
  const cachedUser = JSON.parse(localStorage.getItem('cachedUser'));
  const appStatus = cachedUser && cachedUser.application_status;
  const dualSchoolEnabled = cachedUser && cachedUser.school && cachedUser.school.dual_school_enabled;
  const isDualSchoolParentWithIncompleteApp =
    isAuthenticated &&
    userType === 3 &&
    !isParentViewingAsStudent &&
    schoolType === 'HS' &&
    dualSchoolEnabled &&
    (appStatus === 'not_started' || appStatus === 'in_progress');

  return (
    <div className="App">
      <Router>
        {/* Show special navbar for dual school parents with incomplete application */}
        {isDualSchoolParentWithIncompleteApp ? (
          <ParentApplicationNavbar 
            step={applicationStep} 
            totalSteps={10} 
          />
        ) : (
          /* Show regular navbar for everyone else */
          !isAuthenticated ? <Navbar /> :
          (userType === 2 && schoolType === 'HS' && !isAdminViewingAsStudent) ? <HSNavbar2 /> :
          (userType === 2 && !isAdminViewingAsStudent) ? <Navbar2 /> :
          (userType === 3 && !isParentViewingAsStudent) ? <ParentNavbar /> :
          (userType === 4) ? <BaselinePlanNavbar /> :
          isAdminViewingAsStudent ? <AdminStudentNavbar /> :
          isParentViewingAsStudent ? <ParentStudentNavbar /> : // Parent viewing as student
          <StudentNavbar />
        )}

        <AppRoutes
          isAuthenticated={isAuthenticated}
          userType={userType}
          schoolType={schoolType}
          isAdminViewingAsStudent={isAdminViewingAsStudent}
          isParentViewingAsStudent={isParentViewingAsStudent}
          applicationStep={applicationStep}
          setApplicationStep={setApplicationStep}
        />
      </Router>
    </div> 
  );  
}

export default App;
